/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddressUtxosResponse,
  DisplayPoint,
  DisplayUtxo,
  GetRegulusUtxoParams
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetRegulusAddressUtxosUrl = (address: string,) => {




  return `/api/regulus/address/${address}`
}

export const getRegulusAddressUtxos = async (address: string, options?: Parameters<typeof arbBotFetcher>[1]): Promise<AddressUtxosResponse> => {

  return arbBotFetcher<AddressUtxosResponse>(getGetRegulusAddressUtxosUrl(address),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRegulusAddressUtxosQueryKey = (address: string,) => {
    return [
    `/api/regulus/address/${address}`
    ] as const;
    }


export const getGetRegulusAddressUtxosQueryOptions = <TData = Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError = unknown>(address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegulusAddressUtxosQueryKey(address);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulusAddressUtxos>>> = ({ signal }) => getRegulusAddressUtxos(address, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: address !== null && address !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegulusAddressUtxosQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulusAddressUtxos>>>
export type GetRegulusAddressUtxosQueryError = unknown


export function useGetRegulusAddressUtxos<TData = Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError = unknown>(
 address: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusAddressUtxos>>,
          TError,
          Awaited<ReturnType<typeof getRegulusAddressUtxos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusAddressUtxos<TData = Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusAddressUtxos>>,
          TError,
          Awaited<ReturnType<typeof getRegulusAddressUtxos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusAddressUtxos<TData = Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRegulusAddressUtxos<TData = Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusAddressUtxos>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulusAddressUtxosQueryOptions(address,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRegulusPointUrl = () => {




  return `/api/regulus/point`
}

export const getRegulusPoint = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<DisplayPoint> => {

  return arbBotFetcher<DisplayPoint>(getGetRegulusPointUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRegulusPointQueryKey = () => {
    return [
    `/api/regulus/point`
    ] as const;
    }


export const getGetRegulusPointQueryOptions = <TData = Awaited<ReturnType<typeof getRegulusPoint>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegulusPointQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulusPoint>>> = ({ signal }) => getRegulusPoint({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegulusPointQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulusPoint>>>
export type GetRegulusPointQueryError = unknown


export function useGetRegulusPoint<TData = Awaited<ReturnType<typeof getRegulusPoint>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusPoint>>,
          TError,
          Awaited<ReturnType<typeof getRegulusPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusPoint<TData = Awaited<ReturnType<typeof getRegulusPoint>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusPoint>>,
          TError,
          Awaited<ReturnType<typeof getRegulusPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusPoint<TData = Awaited<ReturnType<typeof getRegulusPoint>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRegulusPoint<TData = Awaited<ReturnType<typeof getRegulusPoint>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusPoint>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulusPointQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRegulusUtxoUrl = (params: GetRegulusUtxoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/regulus/utxo?${stringifiedParams}` : `/api/regulus/utxo`
}

export const getRegulusUtxo = async (params: GetRegulusUtxoParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<DisplayUtxo> => {

  return arbBotFetcher<DisplayUtxo>(getGetRegulusUtxoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRegulusUtxoQueryKey = (params?: GetRegulusUtxoParams,) => {
    return [
    `/api/regulus/utxo`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRegulusUtxoQueryOptions = <TData = Awaited<ReturnType<typeof getRegulusUtxo>>, TError = void>(params: GetRegulusUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegulusUtxoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulusUtxo>>> = ({ signal }) => getRegulusUtxo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegulusUtxoQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulusUtxo>>>
export type GetRegulusUtxoQueryError = void


export function useGetRegulusUtxo<TData = Awaited<ReturnType<typeof getRegulusUtxo>>, TError = void>(
 params: GetRegulusUtxoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusUtxo>>,
          TError,
          Awaited<ReturnType<typeof getRegulusUtxo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusUtxo<TData = Awaited<ReturnType<typeof getRegulusUtxo>>, TError = void>(
 params: GetRegulusUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulusUtxo>>,
          TError,
          Awaited<ReturnType<typeof getRegulusUtxo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulusUtxo<TData = Awaited<ReturnType<typeof getRegulusUtxo>>, TError = void>(
 params: GetRegulusUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRegulusUtxo<TData = Awaited<ReturnType<typeof getRegulusUtxo>>, TError = void>(
 params: GetRegulusUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulusUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulusUtxoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






